module.exports = __webpack_public_path__ + "static/media/bodbanner.1dbe442c.png";